import React, { useState } from "react";
import { useSelector } from "react-redux";
import Loader from "../../components/loader";
import { hasAccess } from "../../utils/roles";

import SelectMonth from "../../components/selectMonth";
import SelectUser from "../../components/selectUser";
import ActivityTable from "../../components/activityTable";

const Activity = () => {
  const u = useSelector((state) => state.Auth.user);

  const [date, setDate] = useState(null);
  const [user, setUser] = useState(u);

  if (user === null) return <Loader />;

  return (
    <div className="bg-white rounded-xl overflow-hidden w-screen md:w-full shadow-sm">
      <div className="flex items-center justify-between px-6 py-4 border-b border-gray-100">
        {/* Clearing the selector falls back to yourself — a null user would leave the page stuck on the loader */}
        <SelectUser
          disabled={!hasAccess({ user: u, access: "admin" })}
          userRoles={["super_admin", "admin", "user"]}
          value={user}
          onChange={(next) => setUser(next || u)}
        />
        <SelectMonth start={-11} indexDefaultValue={11} value={date} onChange={(e) => setDate(e.target.value)} showArrows />
      </div>
      {date && user && <ActivityTable date={new Date(date)} user={user} />}
    </div>
  );
};

export default Activity;
